import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-album-program-detail',
  templateUrl: './album-program-detail.component.html',
  styleUrls: ['./album-program-detail.component.scss']
})
export class AlbumProgramDetailComponent {

  public dataListing:any=[];
  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public currentUrl:any=this.router.url;
  public d_otherSelection:any='';
  public s_otherSelection:any='';
  public t_otherSelection:any='';

  constructor(public router: Router, public service: GlobalService) { 
    var jj = JSON.parse(localStorage.getItem('gra_EditData') || "{}");   
    this.getdetail(jj._id);
   }

  ngOnInit(): void {
  }

  getdetail(id:any){
    var detail={
      id:id
    };
    var url:any='';
    if(this.currentUrl=='/program-detail'){
      url='/program-detail'
    } else {
      url='/album-detail';
    }
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success==1){
        var self=this;
        if(this.currentUrl=='/program-detail'){
        response.data.record[0].program_videos.filter((ell:any)=>{
          response.data.record[0].videos.filter((el:any)=>{
            if(el._id == ell.video_id){
              if(el.thumbnail ==''){
                el.thumbnail = 'assets/images/default_img.png';   
              }
              ell.thumbnail = el.thumbnail ;
              ell.name = el.name ;
              ell.status = el.status ;
              ell.description = el.description ;
              ell.created_new = self.service.convertDate(el.createdAt) ;
            }
          })
        })
        this.dataListing=response.data.record[0].program_videos;
        response.data.record[0].image= response.data.record[0].program_image;
        if( response.data.record[0].program_other_diet !=''){
          self.d_otherSelection=response.data.record[0].program_other_diet;
          response.data.record[0].d_other = response.data.record[0].program_other_diet;
        }
        if( response.data.record[0].program_other_sub_category !=''){
          self.s_otherSelection=response.data.record[0].program_other_sub_category;
          response.data.record[0].s_other = response.data.record[0].program_other_sub_category;
        }
        if( response.data.record[0].program_other_type !=''){
          self.t_otherSelection=response.data.record[0].program_other_type;
          response.data.record[0].t_other = response.data.record[0].program_other_type;
        }
      
      } else {
        response.data.record[0].album_videos.filter((ell:any)=>{
          response.data.record[0].videos.filter((el:any)=>{
            if(el._id == ell.video_id){
              ell.thumbnail = el.thumbnail ;
              ell.name = el.name ;
              ell.status = el.status ;
              ell.description = el.description ;
              ell.created_new = self.service.convertDate(el.createdAt) ;
            }
          })
        })
        this.dataListing=response.data.record[0].album_videos;
        response.data.record[0].image=response.data.record[0].album_image;
        if( response.data.record[0].album_other_diet !=''){
          self.d_otherSelection=response.data.record[0].album_other_diet;
          response.data.record[0].d_other = response.data.record[0].album_other_diet;
        }
        if( response.data.record[0].album_other_sub_category !=''){
          self.s_otherSelection=response.data.record[0].album_other_sub_category;
          response.data.record[0].s_other = response.data.record[0].album_other_sub_category;
        }
        if( response.data.record[0].album_other_type !=''){
          self.t_otherSelection=response.data.record[0].album_other_type;
          response.data.record[0].t_other = response.data.record[0].album_other_type;
        }
      }
      if(response.data.record[0].gender.length == 0){
        response.data.record[0].gender='--';
      }
      if(response.data.record[0].gender.length != 0){
        response.data.record[0].gender=response.data.record[0].gender[0].name;
      }
      if(response.data.record[0].demographic_info.length != 0){
        response.data.record[0].demographics = response.data.record[0].demographic_info[0].name;
      }
      if(response.data.record[0].levels_info.length != 0){
        response.data.record[0].level = response.data.record[0].levels_info[0].name;
      }
      if(response.data.record[0].type_info.length != 0){
        var ss:any='';
        response.data.record[0].type_info.filter((el:any)=>{
          if(ss!=''){
            ss =ss+", " +el.name;
          } else {
            ss=el.name;
          }
        })
        response.data.record[0].types = ss;
      }
      if(response.data.record[0].categories_info.length != 0){
        var ss:any='';
        response.data.record[0].categories_info.filter((el:any)=>{
          if(ss!=''){
            ss =ss+", " +el.name;
          } else {
            ss=el.name;
          }
        })
        response.data.record[0].category = ss;
      }
      if(response.data.record[0].sub_category_info.length != 0){
        var ss:any='';
        response.data.record[0].sub_category_info.filter((el:any)=>{
          if(ss!=''){
            ss =ss+", " +el.name;
          } else {
            ss=el.name;
          }
        })
        response.data.record[0].scategory = ss;
      }
      if(response.data.record[0].diets_info.length != 0){
        response.data.record[0].diet = response.data.record[0].diets_info[0].name;
      }
      if(response.data.record[0].users.length !=0){
        response.data.record[0].userCurrencySymbol =response.data.record[0].users[0].userCurrencySymbol;
        response.data.record[0].creater_name =response.data.record[0].users[0].name+' '+ response.data.record[0].users[0].surname;
      }
      if(response.data.record[0].category_type ==1){
        response.data.record[0].category_Name = 'Standard';
      } else if(response.data.record[0].category_type ==2){
        response.data.record[0].category_Name = 'Nutrition';
      } else {
        response.data.record[0].category_Name = 'Hybrid';
      }
        this.AllData= response.data.record[0];
        // this.dataListing=response.data.record[0].videos;
        this.loading= false;
      } else {
        this.loading=false;
      }
    }))
  }

}
